<template>
    <v-card
        class="prediction-card"
        elevation="0"
        @click="onClick"
        :class="{ clickable: routePath }"
    >
        <div class="top-section">
            <div class="icon-box" :style="{ background: iconBg }">
                <i :class="icon" class="fa-icon"></i>
            </div>

            <div
                v-if="trendValue !== null"
                class="trend"
                :class="trendValue >= 0 ? 'text-success' : 'text-danger'"
            >
                {{ trendValue >= 0 ? "▲" : "▼" }} {{ Math.abs(trendValue) }}%
            </div>
        </div>

        <h2 class="kpi-value">{{ value }}</h2>

        <div class="main-title">{{ title }}</div>

        <div class="sub-text">{{ subText }}</div>

        <div class="graph-line">
            <svg viewBox="0 0 130 38" preserveAspectRatio="none">
                <path
                    :stroke="bottomColor"
                    stroke-width="3"
                    fill="transparent"
                    d="M5 28 C 35 10, 65 40, 125 20"
                />
            </svg>
        </div>
    </v-card>
</template>

<script>
export default {
    name: "PredictionInfoCard",

    props: {
        icon: { type: String, required: true },
        iconBg: { type: String, default: "#eef4ff" },
        title: String,
        subText: String,
        value: [String, Number],
        trendValue: { type: Number, default: null },
        bottomColor: { type: String, default: "#4a90e2" },
        routePath: { type: String, default: "" },
    },

    methods: {
        onClick() {
            if (this.routePath) this.$router.push(this.routePath);
        },
    },
};
</script>

<style scoped>
.prediction-card {
    padding: clamp(12px, 2vw, 18px);
    border-radius: 12px;
    background: white;
    border: 1px solid #efefef;
    min-height: 190px;
    width: 100%;
    transition: 0.2s ease;
}

.prediction-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
}

.clickable {
    cursor: pointer;
}

.top-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.icon-box {
    width: clamp(36px, 4vw, 48px);
    height: clamp(36px, 4vw, 48px);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.fa-icon {
    font-size: clamp(16px, 3vw, 22px);
    color: #333;
}

.trend {
    font-size: clamp(12px, 2vw, 15px);
    font-weight: 600;
}

.kpi-value {
    font-size: clamp(22px, 4vw, 34px);
    font-weight: 700;
    margin: 10px 0 6px;
}

.main-title {
    font-size: clamp(13px, 2.6vw, 15px);
    font-weight: 500;
    color: #222;
}

.sub-text {
    font-size: clamp(12px, 2.4vw, 14px);
    color: #7a7a7a;
    margin-bottom: 8px;
}

.graph-line {
    width: 100%;
    height: 40px;
}

.graph-line svg {
    width: 100%;
    height: 100%;
    display: block;
}

@media (max-width: 480px) {
    .prediction-card {
        min-height: 180px;
    }

    .top-section {
        flex-direction: row;
    }

    .kpi-value {
        margin-top: 6px;
    }
}
</style>
